import React from 'react';
import { getPostAuthorizeParams } from './lib/authorize-utils';
import { LoginCallback } from '@okta/okta-react';
import LoginCallbackError from './LoginCallbackError';
import Loader from './Loader';

const updateQueryParams = (key, value) => {
  const url = new URL(window.location);
  url.searchParams.set(key, value);
  window.history.pushState({}, '', url);
};

const supportedPostParams = ['code', 'interaction_code', 'error', 'error_description'];

function LoginCallbackCustom() {
  const params = getPostAuthorizeParams();
  Object.keys(params || {}).forEach((key) => {
    if (supportedPostParams.includes(key)) {
      updateQueryParams(key, params[key]);
    }
  });
  return <LoginCallback errorComponent={LoginCallbackError} loadingElement={<Loader />} />;
}

export default LoginCallbackCustom;
